"use strict";

var canonical = {
  colorWhite: {
    value: '#ffffff',
    name: 'True White'
  },
  colorNeutralCool: {
    value: '#f9f9f9',
    name: 'Cool Neutral'
  },
  colorNeutralWarm: {
    value: '#f2f0eb',
    name: 'Warm Neutral'
  },
  colorCeramic: {
    value: '#edebe9',
    name: 'Ceramic'
  },
  colorBlack: {
    value: '#000000',
    name: 'True Black'
  },
  colorGreenStarbucks: {
    value: '#006241',
    name: 'Starbucks Green'
  },
  colorGreenAccent: {
    value: '#00754A',
    name: 'Accent Green'
  },
  colorGreenLight: {
    value: '#d4e9e2',
    name: 'Light Green'
  },
  colorHouseGreen: {
    value: '#1E3932',
    name: 'House Green'
  },
  colorGold: {
    value: '#cba258',
    name: 'Rewards Gold'
  },
  colorGoldLight: {
    value: '#dfc49d',
    name: 'Light Gold'
  },
  colorGoldLightest: {
    value: '#faf6ee',
    name: 'Lightest Gold'
  },
  colorRed: {
    value: '#d62b1f',
    name: 'Error Red'
  },
  colorYellow: {
    value: '#fbbc05',
    name: 'Warning Yellow'
  }
};

/* These can be used to create easy variants, such as
 * 10% alpha accent green: `hsla(var(--colorGreenAccentHsl) / 10%)`
 */
var canonicalHsl = {
  colorWhiteHsl: {
    value: '0 0% 100%',
    name: 'True White'
  },
  colorNeutralCoolHsl: {
    value: '0 0% 98%',
    name: 'Cool Neutral'
  },
  colorNeutralWarmHsl: {
    value: '43 21% 94%',
    name: 'Warm Neutral'
  },
  colorCeramicHsl: {
    value: '30 10% 92%',
    name: 'Ceramic'
  },
  colorBlackHsl: {
    value: '0 0% 0%',
    name: 'True Black'
  },
  colorGreenStarbucksHsl: {
    value: '160 100% 19%',
    name: 'Starbucks Green'
  },
  colorGreenAccentHsl: {
    value: '158 100% 23%',
    name: 'Accent Green'
  },
  colorGreenLightHsl: {
    value: '160 32% 87%',
    name: 'Light Green'
  },
  colorHouseGreenHsl: {
    value: '164 31% 17%',
    name: 'House Green'
  },
  colorGoldHsl: {
    value: '39 53% 57%',
    name: 'Rewards Gold'
  },
  colorGoldLightHsl: {
    value: '35 51% 75%',
    name: 'Light Gold'
  },
  colorGoldLightestHsl: {
    value: '40 55% 96%',
    name: 'Lightest Gold'
  },
  colorRedHsl: {
    value: '4 75% 48%',
    name: 'Error Red'
  },
  colorYellowHsl: {
    value: '45 97% 50%',
    name: 'Warning Yellow'
  }
};
var transparent = {
  /* Text colors based on opacities */

  /* Black with alpha */
  colorBlack6: {
    value: 'rgba(0, 0, 0, .06)',
    name: '6% Black'
  },
  colorBlack10: {
    value: 'rgba(0, 0, 0, .1)',
    name: '10% Black'
  },
  colorBlack20: {
    value: 'rgba(0, 0, 0, .2)',
    name: '20% Black'
  },
  colorBlack30: {
    value: 'rgba(0, 0, 0, .3)',
    name: '30% Black'
  },
  colorBlack40: {
    value: 'rgba(0, 0, 0, .4)',
    name: '40% Black'
  },
  colorBlack50: {
    value: 'rgba(0, 0, 0, .5)',
    name: '50% Black'
  },
  colorBlack60: {
    value: 'rgba(0, 0, 0, .6)',
    name: '60% Black'
  },
  colorBlack70: {
    value: 'rgba(0, 0, 0, .7)',
    name: '70% Black'
  },
  colorBlack80: {
    value: 'rgba(0, 0, 0, .8)',
    name: '80% Black'
  },
  colorBlack90: {
    value: 'rgba(0, 0, 0, .9)',
    name: '90% Black'
  },
  /* White with alpha */
  colorWhite10: {
    value: 'rgba(255,255,255, .1)',
    name: '10% White'
  },
  colorWhite20: {
    value: 'rgba(255,255,255, .2)',
    name: '20% White'
  },
  colorWhite30: {
    value: 'rgba(255,255,255, .3)',
    name: '30% White'
  },
  colorWhite40: {
    value: 'rgba(255,255,255, .4)',
    name: '40% White'
  },
  colorWhite50: {
    value: 'rgba(255,255,255, .5)',
    name: '50% White'
  },
  colorWhite60: {
    value: 'rgba(255,255,255, .6)',
    name: '60% White'
  },
  colorWhite70: {
    value: 'rgba(255,255,255, .7)',
    name: '70% White'
  },
  colorWhite80: {
    value: 'rgba(255,255,255, .8)',
    name: '80% White'
  },
  colorWhite90: {
    value: 'rgba(255,255,255, .9)',
    name: '90% White'
  }
};
var functional = {
  colorTextBlack: {
    value: 'rgba(0, 0, 0, .87)',
    name: 'Black Text'
  },
  colorTextBlackSoft: {
    value: 'rgba(0, 0, 0, .58)',
    name: 'Soft Black Text'
  },
  colorTextWhite: {
    value: 'rgba(255, 255, 255, 1)',
    name: 'White Text'
  },
  colorTextWhiteSoft: {
    value: 'rgba(255, 255, 255, .70)',
    name: 'Soft White Text'
  }
};
module.exports = {
  canonical: canonical,
  canonicalHsl: canonicalHsl,
  transparent: transparent,
  functional: functional
};